import { call, select, delay } from 'redux-saga/effects';
import i18next from 'i18next';
import { getGallectionById, getGrusername } from '../selectors';
import type { Action } from 'redux-actions';
import type { ChangeGallectionNamePayload } from '../actions';
import { requestPuppy } from '@wix/da-http-client';
import type { PapiRequestDaSharedGallectionFoldersRename } from '@wix/da-papi-types';
import { getGallectionType } from '../helpers';
import { putErrorNotification } from '../../utils/saga';
import { validateGallectionFoldersRenameRequest } from '../../utils/validation/validateGallectionFoldersRenameRequest';

function* setGallectionName(action: Action<ChangeGallectionNamePayload>) {
  yield delay(500); // + takeLatest = debounced

  const { folderId, name } = action.payload;

  const username: ReturnType<typeof getGrusername> =
    yield select(getGrusername);
  const gallection: ReturnType<typeof getGallectionById> = yield select(
    getGallectionById,
    folderId
  );
  if (!gallection) {
    return;
  }

  const params: PapiRequestDaSharedGallectionFoldersRename = {
    username,
    type: getGallectionType(gallection) ?? 'collection',
    folderid: gallection.folderId,
    name,
  };

  // Validate request data before sending to prevent 400 errors
  const isValid = validateGallectionFoldersRenameRequest(params);
  if (!isValid) {
    yield putErrorNotification(i18next.t('Invalid request data'));
    return;
  }

  yield call(requestPuppy, {
    method: 'post',
    url: 'gallection/folders/rename',
    data: params,
  });
}

export default setGallectionName;
